
import { Component, Prop, Vue } from 'vue-property-decorator'

import { authMethodIsWeak } from '@/helpers/Authentication'
import { authenticationMethod } from '@/helpers/Environment'

import { LanguageStrings } from '@/language/types'
import { openMembershipModal } from '@/modals/membershipModal'
import { logout } from '@/state/Authentication'
import type { CartType } from '@/store/Cart'
import store from '@/store/store'

@Component({ name: 'MembersMenu' })
export default class extends Vue {
  @Prop({ required: true })
  user

  t: LanguageStrings['membersMenu']

  get showAccountLinks() {
    if (authenticationMethod == null) return false
    else {
      const cart: CartType = store.getters['Cart/cart']

      // Disable login for injected carts; direct checkout payment links, cart hand-off and payment for edited orders.
      if (!cart) return true
      else return cart.ownedByPublicIdentity
    }
  }

  openMembershipModal() {
    this.close()
    openMembershipModal()
  }

  async logOut() {
    return logout(this.$router, '/')
  }

  close() {
    const el = this.$refs.memberMenu as HTMLElement
    el.removeAttribute('open')
  }

  get showMySection() {
    return !authMethodIsWeak
  }
}
